import { WOW_RETAIL_ROUTES } from '../../../shared/gameConfig/wowretail/routes';

export type TWeeklyRoutesRoutePaths = {
  dungeon: string;
  overview: string;
  season: string;
};

export const DUNGEON_EXPLORER_ROUTE_PATHS = {
  root: WOW_RETAIL_ROUTES.DungeonExplorer,
  overview: WOW_RETAIL_ROUTES.DungeonExplorerSeason,
  dungeon: WOW_RETAIL_ROUTES.DungeonExplorerDungeon,
  view: WOW_RETAIL_ROUTES.DungeonExplorerView,
  stats: WOW_RETAIL_ROUTES.DungeonExplorerStats,
  statistic: WOW_RETAIL_ROUTES.DungeonExplorerStatistic,
  dungeonStatistic: WOW_RETAIL_ROUTES.DungeonExplorerDungeonStatistic
} as const;

export const getWeeklyRoutesRoutePaths = (useMainPath: boolean): TWeeklyRoutesRoutePaths =>
  useMainPath
    ? {
        dungeon: WOW_RETAIL_ROUTES.WeeklyRoutesDungeon,
        overview: WOW_RETAIL_ROUTES.WeeklyRoutes,
        season: WOW_RETAIL_ROUTES.WeeklyRoutesSeason
      }
    : {
        dungeon: WOW_RETAIL_ROUTES.WeeklyRoutesRevampDungeon,
        overview: WOW_RETAIL_ROUTES.WeeklyRoutesRevamp,
        season: WOW_RETAIL_ROUTES.WeeklyRoutesRevampSeason
      };

export const toHapiRoutePath = (path: string): string => path.replace(/:([^/]+)/g, '{$1}');
